import {isMobile} from '../../../libs/shared/core/src/helpers/environment/mobileEnvHelpers';
import {InstrumentedTimeoutProvider} from '../../../libs/shared/core/src/helpers/instrumentation/timeout';
import {withTimeoutAsync} from '../../../libs/shared/core/src/helpers/utilities/asyncHelpers';
import {decodeRawBoot, RawBoot} from '../../../src/models/api/rawBootModel';
import {bootPath} from './bootConstants';

/*
 * Constants.
 */

const cacheName = 'boot:1';
const defaultReadTimeout = 10 * 1000;
const hasRawBootCache = !isMobile();

/*
 * API.
 */

export async function readRawBootCacheAsync(
  timeoutProvider: InstrumentedTimeoutProvider,
  timeout = defaultReadTimeout,
): Promise<RawBoot | undefined> {
  if (!hasRawBootCache) {
    return undefined;
  }

  if (typeof caches === 'undefined') {
    return undefined;
  }

  // Impose a timeout to hedge against I/O issues.
  return withTimeoutAsync(
    timeoutProvider,
    async () => {
      const cache = await caches.open(cacheName);
      const response = await cache.match(bootPath);

      const body = await response?.json();
      if (!body) {
        return undefined;
      }

      return decodeRawBoot(body);
    },
    timeout,
  );
}

export async function writeRawBootCacheAsync(rawBoot: RawBoot): Promise<void> {
  if (!hasRawBootCache) {
    return;
  }

  const cache = await caches.open(cacheName);
  const response = new Response(JSON.stringify(rawBoot), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  await cache.put(bootPath, response);
}

export async function deleteRawBootCacheAsync(): Promise<void> {
  if (!hasRawBootCache) {
    return;
  }

  await caches.delete(cacheName);
}
